import { render, staticRenderFns } from "./SegmentToggle.vue?vue&type=template&id=39385dd8&"
import script from "./SegmentToggle.vue?vue&type=script&lang=js&"
export * from "./SegmentToggle.vue?vue&type=script&lang=js&"
import style0 from "./SegmentToggle.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports